import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Paper, Typography, Grid } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { saveAccess } from 'core/lib'

import { ProductsListFlat, ProductsListGroupped } from '../Shop/ProductsList'

function Shop({ classes, toggleCategoriesOpen }) {
	const navigate = useNavigate()
	const shop = useSelector(state => state.shop)
	const offers = useSelector(state => state.offers.offers)

	const catDisplayMode = shop.profiles.ueby_categories_display_mode
	const catListDisplayMode =  shop.profiles.ueby_categories_list_display_mode
	const categories = (useSelector(state => state.products.categories))

	useEffect(() => {
		saveAccess('home')
	}, [])

	const gotoOffers = () => {
		navigate('/offers')
	}

	const handleCategorySelected = (ecom_url, subCat) => {
		if (subCat.lenth > 0) {
			navigate(`/shop/${ecom_url}`)
		}
		else {
			navigate(`/shop/${ecom_url}`)
		}
	}

	return (<React.Fragment>
		<div className={classes.homeBackground}></div>
		<div className={classes.homePage}>

			{/* Welcome */}
			<Paper elevation={3} className="box">
				<div dangerouslySetInnerHTML={{
					__html: shop.intro_text
				}}></div>
			</Paper>

			{catDisplayMode == '1' ?
				<div className={classes.page} style={{ width: '91vw' }} >
					{/* Products / Categories */}
					<Grid container spacing={1} className={classes.productsList} >
						{categories.map((category) => (
							<Grid key={category.category_id} item xs={12} sm={6} md={4} lg={3} xl={2}>
								<div className="product grid" onClick={() => handleCategorySelected(category.ecom_url, category.sub_categories)}>

									{parseInt(catListDisplayMode) == 1
										?
										<>
											<div className="pic">
												<img style={{ width: '80%'  }} src={`${window.__endpoint}/images/products/m/${category.main_image ? category.main_image.image_id : 'missing'}.jpg`} alt={category.name} />
											</div>
											<div className="title">
												{category.name}
											</div>
										</>
										:
										<div className="titleContainer">
											<span className="titleCategory">{category.name}</span>
										</div>
									}
								</div>
							</Grid>
						))}

						{offers.length > 0 && <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
							<div className="product grid" onClick={gotoOffers}>
								{parseInt(catListDisplayMode) == 1
									?
									<>
										<div className="pic">
											<img style={{ width: '80%'  }} src={`${window.__endpoint}/images/products/m/${'missing'}.jpg`} alt="Offerte" />
										</div>
										<div className="title">
										Offerte
										</div>
									</>
									:
									<div className="titleContainer" style={{ width: 250, height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
										<span className="titleCategory">Offerte</span>
									</div>
								}
							</div>
						</Grid>}
					</Grid>
				</div>
				: <div/>
			}

			{catDisplayMode == '2' && <ProductsListFlat />}
			{catDisplayMode == '3' && <ProductsListGroupped/>}

		</div>
	</React.Fragment>)
}

export default withStyles(style)(Shop)
